export default "__VITE_ASSET__ObzX1GNN__";